// /*!
//  * React FormControl Library v3.6.0 for FormEngine
//  * 
//  * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
//  * Released under the MIT license
//  * 
//  * 
//  * Date: 2022-03-02T17:08Z
//  * Copyright (c) <2022> <Xio Infotech Private Limited>
//  * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
//  */

import React, { useState, useEffect,useContext } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import { MenuItem, FormHelperText,InputLabel } from '@material-ui/core';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { debounce } from 'lodash';
import ThemeControls from '../Component/AllThemesControl';
import { MasterContext } from '../services/MasterContext';
import elementValidate from '../Component/validation';
import { FormContext } from '../Component/Forms/FormContext';
import { APIGET } from '../services/APIServices';


export default function MultiSelectCheckBox(props) {
  const { useStyle } = ThemeControls;
  const { handleChange } = useContext(FormContext);
  const classes = useStyle();
  const { id, field_type, field_apipath, field_history,option_disable, fields,field_options, field_disabled_Edit, field_id, field_label, field_placeholder, field_disabled, field_value, field_option_src, field_helperText, field_minlength, field_maxlength, field_maxvalue, field_value_type, field_minvalue, field_error_msg_required, field_error_msg_minlength, field_error_msg_maxlength, field_error_msg_minvalue, field_error_msg_maxvalue, field_error_msg_uq, onChange, field_mandatory } = props;
  const [values, setValues] = React.useState([]);
  const [labels, setLabels]= React.useState([]);
  const [fieldDisable, setFieldDisable] = useState(field_disabled);
  const [fieldOptions, setFieldOptions] = React.useState(field_options);
  let { masterData } = React.useContext(MasterContext);

  const isAllSelected = fieldOptions?.length > 0 && values?.length === fieldOptions?.length;

  const field = {
    field_id: field_id,
    field_type: field_type,
    field_disabled: field_disabled,
    field_value: field_value,
    field_helperText: field_helperText,
    field_minlength: field_minlength,
    field_maxlength: field_maxlength,
    field_minvalue: field_minvalue,
    field_maxvalue: field_maxvalue,
    field_value_type: field_value_type,
    field_mandatory: field_mandatory,
    field_error_msg_required: field_error_msg_required,
    field_options: fieldOptions ? fieldOptions : field_options,
    field_label: field_label,
  };

  function handleBlur() {
    elementValidate(field);
  }

  const debouncedGetOptions = debounce(getOptions, 300);

  async function getOptions(props) {
    try {
      if (props.field_option_src_context) {
        if (
          props.field_option_check_local_storage === 'true' &&
          masterData[`${props.field_option_src_context}`] &&
          masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`]
        ) {
          setFieldOptions(
            masterData[`${props.field_option_src_context}`] &&
            masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`]
          );
          // setFieldOptions2(
          //   masterData[`${props.field_option_src_context}`] &&
          //   masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`]
          // );
        } else {
          let APIRES = await APIGET(
            props.field_option_src_context +
            `/` +
            props.field_option_src_critieria
          ).then((APIRES) => {
            let responseArray = new Array();
            let _i = 0;
            if (props.field_select_all_label) {
              let _obj = new Object();
              _obj.option_label = props.field_select_all_label;
              _obj.value = props.field_select_all_value;
              responseArray[_i] = _obj;
              _i++;
            }
            if(APIRES.data&&APIRES.data.length>0){
              Object.keys(APIRES.data).forEach((key) => {
                let _obj = new Object();
                function checkType(lableData) {
                  if (typeof lableData === 'string') {
                    _obj.option_label = APIRES.data[key][lableData];
                    _obj.value = APIRES.data[key][props.field_option_value];
                  } else if (Array.isArray(lableData)) {
                    let label = '';
                    for (const item of lableData) {
                      if (item.column) {
                        label += APIRES.data[key][item.column];
                      } else if (item.string) {
                        label += item.string;
                      }
                    }
                    _obj.option_label = label;
                  } else {
                     
                  }
                }
                function checkValueType(valueData) {
                  if (typeof valueData === 'string') {
                    _obj.value = APIRES.data[key][valueData];
                  } else if (Array.isArray(valueData)) {
                    let value = '';
                    for (const item of valueData) {
                      if (item.column) {
                        value += APIRES.data[key][item.column];
                      } else if (item.string) {
                        value += item.string;
                      }
                    }
                    _obj.value = value;
                  } else {
                     
                  }
                }
                checkType(props.field_option_label);
                checkValueType(props.field_option_value);
                responseArray[_i] = _obj;
                _i++;
              });
              const sortedFieldOptions = [...responseArray].sort((a, b) => {
                const labelA = a.option_label || '';
                const labelB = b.option_label || '';
                return labelA.localeCompare(labelB);
              });
    
            const Options = sortedFieldOptions.map(item => ({
                option_label: item.option_label === "" ? "Empty" : item.option_label,
                value: item.value === "" ? " " : item.value
            }));
      
              setFieldOptions(Options);
                
              if (masterData[`${props.field_option_src_context}`]) {
                masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = Options;
              } else {
                masterData[`${props.field_option_src_context}`] = {};
                masterData[`${props.field_option_src_context}`][`${props.field_option_src_critieria}`] = Options;
              }
            }else{
                const responseArray = [
                  {
                    "option_label": "Data Not Found",
                    "value": "0"
                  }
                ];
  
                setFieldOptions(responseArray);
            }
          });
        }
      }
    } catch (err) {
      // //console.log(err)
    } finally {
      // setLoading(false);
    }
  }

  useEffect(() => {
    if (props.field_option_src.field_option_src_critieria) {
      // setValues([])
      // setLabels([])
      // handleChange(field_id, {}, '')
      debouncedGetOptions(field_option_src);
    }
  }, [props.field_option_src.field_option_src_critieria]);

  useEffect(() => {
    if (field_value) {
      let field_values = field_value_type === 'string'&&field_value ? field_value.split(/,\s*|\s*,/) : field_value ? field_value : []
      setValues(field_values);
      const matchedLabels = field_values?.map(val => {
        const matchedOption = fieldOptions?.find(option => option.value === val);
        return matchedOption ? matchedOption.option_label : null;
      });
      setLabels(matchedLabels)
      }else{
        setValues([])
        setLabels([])
      }
  }, [field_value, fieldOptions]);


  useEffect(() => {
    if (typeof id === 'number' && field_disabled_Edit === 'yes' && field_value) {
      setFieldDisable(true);
    } else {
      setFieldDisable(field_disabled);
    }
  }, [field_disabled]);

  const handleChangeCheck = (event) => {
    const value = event.target.value;
    if (value[value.length - 1] === "all") {
      const AllValue = values?.length === fieldOptions?.length ? [] : fieldOptions.map(name =>name.value)
      const AllLabel = values?.length === fieldOptions?.length ? [] : fieldOptions.map(name =>name.option_label)
      setLabels(AllLabel)
      setValues(AllValue);
      handleChange(field_id, {}, field_value_type === 'string' ? AllValue.join(', ') : AllValue);
      return;
    }else{
      handleChange(field_id, {}, field_value_type === 'string' ? value.join(', ') : value)
      setValues(value);
      const matchedLabels = value.map(val => {
        const matchedOption = fieldOptions.find(option => option.value == val);
        return matchedOption ? matchedOption.option_label : null;
      });
      setLabels(matchedLabels)
    }
  };

  return (
    <div className={classes.inputroot}>
    <div style={{ display: 'flex' }}>
      <InputLabel className={classes.label}>{field_label}</InputLabel>
      {field_mandatory === 'yes' ? (
        <span
          style={{
            fontSize: '18px',
            color: '#d71729',
            fontWeight: '400',
            lineHeight: '20px',
            transform: 'translateY(-2px)',
          }}
        >
          *
        </span>
      ) : null}
    </div>
        <Select
          className={classes.select}
          id={field_id}
          multiple
          disabled={fieldDisable}
          value={values}
          renderValue={() => labels.join(", ")}
          onBlur={handleBlur}
          onChange={handleChangeCheck}
          input={<OutlinedInput />}
        >
          {/* <MenuItem value="[]">Multiple Select</MenuItem> */}
              {fieldOptions.length > 1 && <MenuItem value="all" >
                <Checkbox 
                // checked={selectAll} 
                checked={isAllSelected}
                indeterminate={
                  values.length > 0 && values.length < fieldOptions.length
                }
                />
                <ListItemText primary="Select All" />
              </MenuItem>}
          {fieldOptions.map((name) => (
            <MenuItem key={name.value} value={name.value} disabled={name.option_label==='Loading...'||name.option_label==='Data Not Found'?true:option_disable?name.option_label=== option_disable:false}>
              {/* {name.option_label} */}
              <Checkbox checked={labels.indexOf(name.option_label) > -1} />
              <ListItemText primary={name.option_label} />
            </MenuItem>
          ))}
        </Select>
      <FormHelperText>{field_helperText}</FormHelperText>
      {/* </div> */}
    </div>
  );
}
